/**
 * The programs of the suite. `ready` ones open their own interface, served by the API.
 */
export const GROUPS = [
  { key: 'slopes', title: 'Slopes', keys: ['le', '2d', '3d'] },
  { key: 'rock', title: 'Rock', keys: ['kinematic', 'rock', 'tunnel'] },
  { key: 'foundations', title: 'Foundations and ground', keys: ['bearing', 'correlation', 'liquefaction', 'settle', 'pile'] },
  { key: 'retaining', title: 'Retaining structures', keys: ['spwa', 'msew', 'wall'] },
]

export const PROGRAMS = {
  le: {
    name: 'Limit Equilibrium',
    short: 'LE',
    summary: 'Slope stability by Bishop, Janbu, Spencer and Morgenstern–Price with automatic critical-surface search.',
    ready: true,
  },
  '2d': {
    name: '2D Finite Elements',
    short: '2D',
    summary: 'Slopes, embankments and excavations by strength reduction.',
    ready: false,
  },
  '3d': {
    name: '3D Finite Elements',
    short: '3D',
    summary: 'Three-dimensional slopes, excavations and foundations by finite elements.',
    ready: false,
  },
  kinematic: {
    name: 'Rock Kinematics',
    short: 'KIN',
    summary: 'Stereonet kinematic screening, wedge, planar and toppling failure, bolt design.',
    ready: true,
  },
  rock: {
    name: 'Rock Mass Strength',
    short: 'HB',
    summary: 'Generalised Hoek–Brown strength and modulus of the rock mass.',
    ready: true,
  },
  tunnel: {
    name: 'Tunnels',
    short: 'TUN',
    summary: 'Tunnel excavation and support: convergence–confinement and lining design.',
    ready: false,
  },
  bearing: {
    name: 'Bearing Capacity',
    short: 'BC',
    summary: 'Shallow foundations by every classic method and EN 1997-1.',
    ready: true,
  },
  correlation: {
    name: 'Soil Parameter Correlations',
    short: 'COR',
    summary: 'Soil parameters from SPT, CPT and laboratory tests with the scatter of each correlation; hands off to Settle and Bearing.',
    ready: true,
  },
  liquefaction: {
    name: 'Liquefaction',
    short: 'LIQ',
    summary: 'SPT and CPT triggering (Idriss & Boulanger, NCEER, Cetin, TBDY 2018), settlement, lateral spreading, LPI and LSN.',
    ready: true,
  },
  settle: {
    name: 'Settlement',
    short: 'SET',
    summary: 'Immediate, consolidation and secondary settlement with time curves.',
    ready: true,
  },
  pile: {
    name: 'Pile Capacity',
    short: 'PILE',
    summary: 'Axial capacity and settlement of single piles, groups and rock sockets.',
    ready: true,
  },
  spwa: {
    name: 'Pile Wall Analysis',
    short: 'PWA',
    summary: 'Steel sheet piles or reinforced concrete bored piles: free-earth support and Winkler beam-spring analysis with stages.',
    ready: true,
  },
  msew: {
    name: 'MSE Walls',
    short: 'MSE',
    summary: 'Mechanically stabilised earth walls: external and internal stability.',
    ready: true,
  },
  wall: {
    name: 'Retaining Walls',
    short: 'RW',
    summary: 'Cantilever RC retaining walls: stability, TBDY 2018 and TS 500 design.',
    ready: true,
  },
}
